import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import NavLink from '../nav_link';
import StorageList from './jetList-admin--storage';

const styles = () => ({
    topic: {
        paddingLeft: '32px',
        maxHeight: '40px',
        paddingRight: '1.0rem',
    },
});

class JetListAdministration extends React.Component {
    //
    state = {
        openStorage: false,
    };
    handleClickStorage = (event) => {
        let current = !this.state.openStorage;
        if (!event) {
            current = true;
        }
        this.setState({
            openStorage: current,
        });
    };
    preventAction = (e) => {
        e.preventDefault();
    };

    //

    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Collapse component="li" in={this.props.isOpen} timeout="auto">
                    <List disablePadding>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/administration/configuring-endpoints"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Configuring Endpoints" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/administration/managing-routes"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Building Routes" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/administration/partner-routes"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Building Partner Routes" />
                            </ListItem>
                        </NavLink>

                        <NavLink onClick={this.preventAction} to="/jet/administration/storage-profile/">
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Storage Profiles" />
                            </ListItem>
                        </NavLink>

                        <StorageList
                            handleDrawerToggle={this.props.handleDrawerToggle}
                            onActive={() => {
                                this.handleClickStorage();
                                this.props.onActive();
                            }}
                        />

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/administration/adding-removing-users"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Adding and Removing Users" />
                            </ListItem>
                        </NavLink>
                    </List>
                </Collapse>
            </React.Fragment>
        );
    }
}

JetListAdministration.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default withStyles(styles)(JetListAdministration);
